import React from 'react'

const MyAccountIcon = ({active}) => {
    return (
        <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.9919 0.5C8.55714 0.5 5.76953 3.28605 5.76953 6.71879C5.76953 10.0853 8.40781 12.8216 11.9089 12.9211C11.9587 12.9211 12.0251 12.9211 12.0582 12.9211C12.0914 12.9211 12.1412 12.9211 12.1744 12.9211C12.191 12.9211 12.2076 12.9211 12.2076 12.9211C15.5594 12.805 18.1976 10.0853 18.2142 6.71879C18.2142 3.28605 15.4266 0.5 11.9919 0.5Z" fill={active? "white": "black"} />
            <path d="M23.25 21.1054C20.2965 23.8251 16.3473 25.5001 12 25.5001C7.65265 25.5001 3.70354 23.8251 0.75 21.1054C1.14823 19.5963 2.22677 18.2199 3.8031 17.1585C8.33296 14.1403 15.7002 14.1403 20.1969 17.1585C21.7898 18.2199 22.8518 19.5963 23.25 21.1054Z" fill={active? "white": "black"} />
        </svg>
    )
}

export default MyAccountIcon
